import SchemaForm from '@/components/_common/SchemaForm/SchemaForm';
import useRegisterOrderFormRef from '@/components/_hooks/useRegisterOrderFormRef';
import { SchemaFormRefSource } from '@/redux/slices/slice_types';
import { useRef } from 'react';

const OrderProfileForm = ({
  orderProfileSchema,
  job,
  handleProfileSchemaFormChange
}: {
  orderProfileSchema: any;
  job: any;
  handleProfileSchemaFormChange: (data: { formData: Record<string, any> }) => void;
}) => {
  const formRef = useRef<any>(null);
  useRegisterOrderFormRef({
    disabled: false,
    formRef,
    key: SchemaFormRefSource.PROFILE_DETAIL_INFO
  });

  const handleProfileSchemaFormSubmit = () => {
    return undefined;
  };

  return (
    <SchemaForm
      formRef={formRef}
      tagName="div"
      schema={orderProfileSchema}
      formData={job.order_profile_inputs}
      liveOmit
      onChange={handleProfileSchemaFormChange}
      extraData={{ profile: job.profile }}
      onSubmit={handleProfileSchemaFormSubmit}
    />
  );
};

export default OrderProfileForm;
